import { render, staticRenderFns } from "./WorkflowFormPasso.vue?vue&type=template&id=396f7116"
import script from "./WorkflowFormPasso.vue?vue&type=script&lang=js"
export * from "./WorkflowFormPasso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports